/*
  HEROCK — Microinteracciones (filosofía Emil Kowalski).
  Bump del ícono del carrito al agregar producto: 1 -> 1.15 -> 1 (~200ms).
  Implementado con transiciones CSS (interrumpible), no keyframes.
  Respeta prefers-reduced-motion.
*/
(() => {
  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let bumpTimer;

  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    if (reducedMotion.matches) return;
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;

    clearTimeout(bumpTimer);
    cartIcon.classList.add('hr-cart-bump');
    bumpTimer = setTimeout(() => cartIcon.classList.remove('hr-cart-bump'), 100);
  });
})();

/* Enlaces que abren un acordeón de la misma página en vez de navegar.
   Sin JS el navegador ya salta al ancla, y los navegadores modernos abren
   solos el <details> al hacerlo; esto añade el desplazamiento suave y cubre
   a los que no lo hacen. Delegado, así funciona con el selector de variante
   que Shopify vuelve a pintar al cambiar de talla o color. */
document.addEventListener('click', (evento) => {
  const enlace = evento.target.closest('a[data-hr-abrir-acordeon]');
  if (!enlace) return;

  const destino = document.querySelector(enlace.getAttribute('href'));
  if (!destino) return; // sin destino, que el navegador haga lo suyo

  evento.preventDefault();
  destino.open = true;

  const suave = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ? 'auto'
    : 'smooth';
  destino.scrollIntoView({ behavior: suave, block: 'center' });

  // El foco va al resumen del acordeón: quien navega con teclado o lector de
  // pantalla continúa desde donde acaba de mirar, no desde el principio.
  const resumen = destino.querySelector('summary');
  if (resumen) resumen.focus({ preventScroll: true });
});
